export const storage = {
  hash: '@mdc/hash',
  showPushCount: '@mdc/showPushCount',
  showPushInfoAlert: '@mdc/showPushInfoAlert',
  enabledInitCount: '@mdc/enabledInitCount',
};
